import type { AssigneeSource } from "../../../../shared/workspaceAssignees";
export type { AssigneeSource } from "../../../../shared/workspaceAssignees";

interface DirectoryIdentity {
  id?: string;
  remoteId?: string;
  name: string;
  source?: AssigneeSource;
  providerRemoteIds?: string[];
}

/** Provider ids are aliases for display; only the canonical LedAI id is selected. */
export function preferWorkspaceCandidate<T extends {
  remoteId: string;
  projectUserRemoteId?: string;
  loginInformationRemoteId?: string;
  name: string;
  source?: AssigneeSource;
}>(candidate: T, directory: DirectoryIdentity[]): T {
  const ids = [candidate.remoteId, candidate.projectUserRemoteId, candidate.loginInformationRemoteId].filter(Boolean);
  const matches = directory.filter(option => option.source === "ledai" && (
    ids.includes(option.id ?? option.remoteId) || option.providerRemoteIds?.some(id => ids.includes(id))
  ));
  if (matches.length !== 1) return candidate;
  const member = matches[0]!;
  return {
    ...candidate,
    remoteId: member.id ?? member.remoteId!,
    projectUserRemoteId: undefined,
    loginInformationRemoteId: undefined,
    name: member.name,
    source: "ledai",
  };
}

export function assigneeSourceFor(id?: string | null, source?: AssigneeSource, provider?: AssigneeSource): AssigneeSource | undefined {
  return id?.startsWith("ledai:") ? "ledai" : source ?? (id ? provider : undefined);
}
